
// Chakra imports
import { Box, SimpleGrid } from '@chakra-ui/react';
import { useEffect } from 'react';
import useAuth from 'views/auth/signIn/hooks/useAuth';

export default function Logout() {

    const {logOff} = useAuth();
    useEffect(()=> {
        logOff();
    });
	return (
		<Box pt={{ base: '130px', md: '80px', xl: '80px' }}>
		<SimpleGrid mb='20px' columns={{ sm: 1, md: 2 }} spacing={{ base: '20px', xl: '20px' }}>

		</SimpleGrid>
	</Box>
	);
}
